import { FormattedMessage } from 'react-intl';
import { type Schedule } from '@accounts';
import { ScheduleCard } from '@accounts';

interface Props {
  schedules: Schedule[];
  onChoose: (schedule: Schedule) => void;
}

export default function SchedulePicker({ schedules, onChoose }: Props) {
  return (
    <div>
      <h3 className="text-base font-semibold text-slate-900">
        <FormattedMessage id="preparation.schedules.title" values={{ count: schedules.length }} />
      </h3>
      <p className="mt-1 text-sm text-slate-600">
        <FormattedMessage id="preparation.schedules.hint" />
      </p>

      <ul className="mt-4 grid gap-3 sm:grid-cols-2">
        {schedules.map((schedule) => (
          <li key={schedule.id}>
            <button
              type="button"
              onClick={() => onChoose(schedule)}
              className="w-full rounded-2xl border border-slate-200 text-left transition hover:border-brand-300 hover:bg-brand-50/30 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-300"
            >
              <ScheduleCard schedule={schedule} />
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
